import { UserProfile } from "../../models/models";
import {Phone} from "../../models/phone.model";
import {ClientStateContext} from "../../quoteWizard/clientstatecontext.model";

export class ClientStateContextSearchDetailViewModel {

    clientStateContextId:string;
    clientStateContext: ClientStateContext;
    primaryContact: UserProfile;
    primaryContactPhone: Phone;
    primaryContactId: string;

}